import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import usersReducer from './usersSlice';
import sourcesReducer from './sourcesSlice';
import videoSourcesReducer from './videoSourcesSlice';
import suppliersReducer from './suppliersSlice';
import platformsReducer from './platformsSlice';
import sensorsReducer from './sensorsSlice';
import channelsReducer from './channelsSlice';
import pipelinesReducer from './pipelinesSlice';
import mappingsReducer from './mappingsSlice';
import schemasReducer from './schemasSlice';
import recordsReducer from './recordsSlice';
import websocketReducer from './websocketSlice';
import monitoringReducer from './monitoringSlice';
import filmstripPersistenceMiddleware, { loadMonitoringState } from './filmstripPersistenceMiddleware';

// Load persisted monitoring state (includes filmstrip and ATR data)
const persistedMonitoringState = loadMonitoringState();

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    sources: sourcesReducer,
    videoSources: videoSourcesReducer,
    suppliers: suppliersReducer,
    platforms: platformsReducer,
    sensors: sensorsReducer,
    channels: channelsReducer,
    pipelines: pipelinesReducer,
    mappings: mappingsReducer,
    schemas: schemasReducer,
    records: recordsReducer,
    websocket: websocketReducer,
    monitoring: monitoringReducer,
  },
  preloadedState: persistedMonitoringState ? {
    monitoring: {
      // Initialize with default monitoring state
      messages: [],
      timeSeriesData: [],
      selectedInterval: null,
      selectedIntervalMessages: [],
      lastUpdateTime: null,
      persistentSourceColors: {},
      persistentSourceOrder: [],
      sourceLastSeen: {},
      selectedSource: 'total',
      videoThumbnails: {},
      videoSourceActivity: {},
      lastVideoUpdateTime: null,
      // Merge in the persisted monitoring state (includes ATR data and filmstrip state)
      ...persistedMonitoringState
    }
  } : undefined,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['websocket/setSocket'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.socket'],
        // Ignore these paths in the state
        ignoredPaths: ['websocket.socket'],
      },
    }).concat(filmstripPersistenceMiddleware),
});

// Export RootState type for TypeScript
export const RootState = undefined; // Placeholder for JS compatibility
export const AppDispatch = undefined; // Placeholder for JS compatibility

export default store;
